<template>
    <div class="the-top" v-if="allowedVariableTypes">
        <div class="checkbox" v-if="!isRequired">
            <label>
                <input
                    type="checkbox"
                    v-model="isIncluded"
                    :disabled="isIncludeDisabled"
                    @change="includedClicked()"
                    v-focus
                />{{ title }}
            </label>
        </div>
        <div class="radio" role="radiogroup" aria-label="Select Variable Type">
            <label v-if="allowedVariableTypes.year">
                <input
                    type="radio"
                    :name="'variableType1_' + variableType"
                    v-model="selectedType"
                    value="year"
                    :disabled="!isVariableTypeSelectionEnabled"
                    v-focus-if="
                        isIncludeDisabled && variableType !== 'control2'
                    "
                    v-on:change="selectedTypeChanged('year')"
                />
                Year
            </label>
            <label v-if="allowedVariableTypes.location">
                <!-- v-model="selectedType"  
                           v-on:change="selectedTypeChanged"-->
                <input
                    type="radio"
                    :name="'variableType2_' + variableType"
                    v-model="selectedType"
                    value="location"
                    :disabled="!isVariableTypeSelectionEnabled"
                    v-on:change="selectedTypeChanged('location')"
                />
                Location
            </label>
            <label v-if="allowedVariableTypes.variable">
                <input
                    type="radio"
                    :name="'variableType3_' + variableType"
                    v-model="selectedType"
                    value="variable"
                    :disabled="!isIncluded"
                    v-on:change="selectedTypeChanged('variable')"
                />
                Variable
            </label>
        </div>
        <div v-if="allowedVariableTypes.variable">
            <label :for="selectListId" class="sr-only">Variable</label>
            <div class="variable-group">
                <label
                    >Topic
                    <select
                        v-model="selectedGroupId"
                        :disabled="!isVariableSelectionEnabled"
                        v-focus-if="
                            isIncludeDisabled &&
                            !isVariableTypeSelectionEnabled &&
                            variableType !== 'control2'
                        "
                        v-on:change="selectedGroupIdChanged"
                    >
                        <option
                            v-for="group in availableGroupsWithAll"
                            v-bind:value="group.id"
                            v-bind:key="group.id"
                        >
                            {{ group.title }}
                        </option>
                    </select>
                </label>
            </div>
            <div class="dataTables-filter" v-if="selectedGroupId === 'all'">
                <input
                    type="search"
                    class="search-text-box"
                    placeholder="Search All"
                    aria-label="Search All"
                    v-model="searchText"
                />
            </div>
            <div class="the-select-list">
                <single-select-list
                    :bind="selectedGroupVariables"
                    :startingSelectedValue="selectedVariableName"
                    :isEnabled="isVariableSelectionEnabled"
                    :listId="selectListId"
                    :showGroup="selectedGroupId === 'all'"
                    :searchText="searchText"
                    v-on:variableIsSelected="(v) => (selectedVariableName = v)"
                ></single-select-list>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint no-unused-vars: 'off' */

import variableDataAccess from '@/scripts/variableDataAccess';
import singleSelectList from '@/components/singleSelectList';
import current from '@/scripts/current';
import commonModelHelper from '@/scripts/commonModelHelper';
import VariableSelection from '@/bo/VariableSelection';
import VariableObject from '@/bo/VariableObject';
import VariableGroup from '@/bo/VariableGroup';
import store from '@/store';

function getIsVariableSelectionEnabled(variableType, isIncluded, selectedType) {
    return variableType === 'independent'
        ? selectedType === 'variable'
        : isIncluded && selectedType === 'variable';
}
function getSelectedGroupVariables(availableGroupsWithAll, selectedGroupId) {
    var results = selectedGroupId
        ? availableGroupsWithAll.filter((g) => g.id === selectedGroupId)[0]
              .variables
        : [];
    results.forEach((v) => (v.value = v.variable));

    //var a = results[0];
    return results;
}

function getSelectedVariable(theSelectedGroup, variableSelection) {
    if (
        !theSelectedGroup ||
        !variableSelection ||
        !variableSelection.hasASelectedVariable ||
        variableSelection.type !== 'variable' ||
        !variableSelection.variable
    )
        return null;
    //Get variables from group for population
    var variables = theSelectedGroup.variables.filter(
        (v) => v.variable === variableSelection.variable.variable
    );
    return variables.length > 0 ? variables[0] : null;
}

function getVariableToEmit(
    isIncluded,
    selectedType,
    theSelectedVariableName,
    availableGroups
) {
    if (isIncluded && selectedType === 'year') {
        // return new VariableSelection(/*variable=*/null, 'year', true);
        return VariableSelection.newYear();
    } else if (isIncluded && selectedType === 'location')
        // return new VariableSelection(/*variable=*/null, 'location', true);
        return VariableSelection.newLocation();
    else if (
        isIncluded &&
        selectedType === 'variable' &&
        theSelectedVariableName
    ) {
        var selectedGroups = availableGroups.filter(
            (g) =>
                g.variables.filter(
                    (v) => v.variable === theSelectedVariableName
                ).length > 0
        );
        if (selectedGroups.length > 0) {
            const theSelectedVariable = selectedGroups[0].variables.filter(
                (v) => v.variable === theSelectedVariableName
            )[0];
            return new VariableSelection(
                VariableObject.copy(theSelectedVariable),
                'variable',
                true,
                VariableGroup.copy(selectedGroups[0])
            );
        }
    }
    //Default
    //return VariableSelection.newNotIncluded();
    return new VariableSelection(/*variable=*/ null, 'variable', isIncluded);
}

function hasValidSelection(theVariable, allowedVariableTypes) {
    return (
        theVariable &&
        theVariable.type &&
        allowedVariableTypes[theVariable.type] &&
        theVariable.isSelected()
    );
}

export default {
    props: [
        'value',
        'variableType',
        'title',
        'isRequired',
        'theVariable',
        'isDependent'
    ],
    computed: {
        isEnabled: function () {
            return this.theVariable.include;
        },
        commonModelHelper: function () {
            return commonModelHelper;
        }
        // isVariableSelected: function () {
        //     const vm = this;
        //     console.log(
        //         'isVariableSelected',
        //         vm.selectedType,
        //         vm.selectedType === 'variable'
        //     );
        //     return vm.selectedType === 'variable';
        // }
    },
    mounted() {},
    watch: /*no deep*/ {
        selectedVariableName() {
            //watch
            var vm = this;
            vm.$emit(
                'variableIsSelected',
                getVariableToEmit(
                    vm.isIncluded,
                    vm.selectedType,
                    vm.selectedVariableName,
                    vm.availableGroups
                )
            );
        }
    },
    components: {
        'single-select-list': singleSelectList
    },
    //   created() {
    //       const vm = this;
    //       vm.updateSelection({
    //         omittedVariables: vm.theOmittedVariables,
    //       });
    //   },
    data() {
        var vm = this;

        let vmData = {
            //refreshIndex: 0,
            //Constants
            selectListId: vm.variableType + 'SelectList',
            allowedVariableTypes: null,
            //Variables
            availableGroups: null,
            availableGroupsWithAll: null,
            theGroupForAll: null,
            selectedType: null,
            searchText: '',
            isIncluded: null,
            isIncludeDisabled: null,
            isVariableTypeSelectionEnabled: null,
            isVariableSelectionEnabled: null,
            selectedGroupId: null,
            omittedVariables: null,
            parentIsNotSelected: false,
            selectedGroupVariables: [],
            selectedVariableName: null //This is only used for variable selection list.  Null if year or location
        };
        return vmData;
    },
    methods: {
        includedClicked,
        selectedTypeChanged,
        selectedGroupIdChanged,
        updateSelection,
        updatePropertiesForNewVariable,
        selectedVariableChanged
    }
};

function includedClicked() {
    var vm = this;
    if (!vm.isIncluded) {
        vm.updatePropertiesForNewVariable(
            commonModelHelper.getResetVariable(
                vm.allowedVariableTypes,
                vm.selectedType,
                vm.selectedGroupId,
                vm.availableGroups
            )
        );
        vm.selectedGroupId = null;
    } else vm.selectedGroupId = 'all';

    vm.isVariableSelectionEnabled = getIsVariableSelectionEnabled(
        vm.variableType,
        vm.isIncluded,
        vm.selectedType
    );
    vm.selectedGroupVariables = getSelectedGroupVariables(
        vm.availableGroupsWithAll,
        vm.selectedGroupId
    );
    vm.searchText = '';
    //vm.emit('input', new VariableSelection(/*variable=*/null, vm.selectedType, vm.isIncluded));
    vm.$emit(
        'variableIsSelected',
        getVariableToEmit(
            vm.isIncluded,
            vm.selectedType,
            vm.selectedVariableName,
            vm.availableGroups
        )
    );
}

function selectedTypeChanged(selectedType) {
    var vm = this;
    if (selectedType) vm.selectedType = selectedType;
    vm.selectedGroupId = null;
    if (vm.isIncluded && vm.selectedType === 'variable')
        vm.selectedGroupId = 'all';
    vm.selectedVariableName = null;
    vm.isVariableSelectionEnabled = getIsVariableSelectionEnabled(
        vm.variableType,
        vm.isIncluded,
        vm.selectedType
    );
    vm.selectedGroupVariables = getSelectedGroupVariables(
        vm.availableGroupsWithAll,
        vm.selectedGroupId
    );
    vm.searchText = '';
    vm.$emit(
        'variableIsSelected',
        getVariableToEmit(
            vm.isIncluded,
            vm.selectedType,
            vm.selectedVariableName,
            vm.availableGroups
        )
    );
}

function selectedGroupIdChanged() {
    const vm = this;
    vm.selectedVariableName = null;
    vm.selectedGroupVariables = getSelectedGroupVariables(
        vm.availableGroupsWithAll,
        vm.selectedGroupId
    );
    vm.searchText = '';
    vm.$emit(
        'variableIsSelected',
        getVariableToEmit(
            vm.isIncluded,
            vm.selectedType,
            vm.selectedVariableName,
            vm.availableGroups
        )
    );
}

function selectedVariableChanged(variableName) {
    const vm = this;
    vm.selectedVariableName = variableName;
}

function updateSelection({
    omittedVariables = null,
    isRefresh = false,
    isParentIncluded = false
}) {
    let vm = this;
    const typeToUse = isRefresh ? vm.selectedType : null;
    const groupIdToUse = isRefresh ? vm.selectedGroupId : null;
    const isRequired = Boolean(vm.isRequired);
    vm.parentIsNotSelected = vm.isDependent && !isParentIncluded;
    vm.omittedVariables = omittedVariables;

    vm.allowedVariableTypes = current.modelHelper.getAllowedSelections(
        vm.variableType,
        vm.omittedVariables
    );
    let hasAValidSelection = hasValidSelection(
        vm.theVariable,
        vm.allowedVariableTypes
    );
    vm.isIncluded = false;
    if (!isRefresh && vm.theVariable.include && hasAValidSelection) {
        vm.isIncluded = true;
    }
    if (vm.allowedVariableTypes.isRequired || isRequired) vm.isIncluded = true;
    if (vm.parentIsNotSelected) vm.isIncluded = false;
    if (vm.variableType === 'column') vm.isIncluded = true;

    //console.log('setIsIncluded', vm.isIncluded);
    vm.availableGroups = vm.allowedVariableTypes.variable
        ? variableDataAccess.getVariablesByGroups(
              store.state.selModel.years.values,
              vm.variableType,
              vm.omittedVariables
          )
        : [];
    vm.theGroupForAll = new VariableGroup(
        'all',
        'Search All',
        buildListWithAllVariables(vm.availableGroups)
    );
    vm.availableGroupsWithAll = getAvailableGroups(
        vm.availableGroups,
        vm.theGroupForAll
    );

    vm.selectedType = typeToUse;
    if (
        (!vm.selectedType || !vm.allowedVariableTypes[vm.selectedType]) &&
        hasAValidSelection &&
        vm.isIncluded &&
        vm.theVariable.include &&
        vm.theVariable
    )
        vm.selectedType = vm.theVariable.type;
    if (!vm.selectedType || !vm.allowedVariableTypes[vm.selectedType])
        vm.selectedType = vm.allowedVariableTypes.defaultType;

    const theSelectedGroup = getSelectedGroup(
        vm.availableGroups,
        vm.theVariable.group,
        vm.theGroupForAll,
        vm.selectedType,
        vm.isIncluded,
        groupIdToUse
    );
    vm.selectedGroupId = theSelectedGroup ? theSelectedGroup.id : null;
    const theSelectedVariable = getSelectedVariable(
        theSelectedGroup,
        vm.theVariable
    );
    if (hasValidSelection && theSelectedVariable)
        vm.selectedVariableName = theSelectedVariable.variable;

    vm.isIncludeDisabled =
        vm.parentIsNotSelected ||
        vm.variableType === 'row' ||
        vm.allowedVariableTypes.isRequired ||
        !vm.allowedVariableTypes.isAllowed;

    vm.isVariableTypeSelectionEnabled =
        vm.isIncluded && vm.allowedVariableTypes.count > 1;
    vm.selectedGroupVariables = getSelectedGroupVariables(
        vm.availableGroupsWithAll,
        vm.selectedGroupId
    );
    vm.isVariableSelectionEnabled = getIsVariableSelectionEnabled(
        vm.variableType,
        vm.isIncluded,
        vm.selectedType
    );
    let updatedVariable = getVariableToEmit(
        vm.isIncluded,
        vm.selectedType,
        vm.selectedVariableName,
        vm.availableGroups
    );
    vm.$emit('variableIsSelected', updatedVariable);
    store.dispatch('selModel/setReadyForNextStep'); //todo: uncomment this
}

function updatePropertiesForNewVariable(updatedVariable) {
    var vm = this;
    vm.isIncluded = updatedVariable.include;
    vm.selectedType = updatedVariable.type;
    vm.selectedGroupId =
        updatedVariable.group === null
            ? vm.theGroupForAll.id
            : updatedVariable.group.id;
    vm.selectedVariableName =
        updatedVariable.variable.variable === null
            ? null
            : updatedVariable.variable.variable;
}

function getAvailableGroups(availableGroups, theGroupForAll) {
    if (!availableGroups || availableGroups.length === 0) return [];
    var groups = availableGroups.slice();
    groups.unshift(theGroupForAll); //Add all to beginning of list
    return groups;
}

function buildListWithAllVariables(availableGroups) {
    var vm = this;
    if (!availableGroups) return [];
    var theVariables = [];
    availableGroups.forEach(
        (g) => (theVariables = theVariables.concat(g.variables))
    );
    theVariables.sort((a, b) => {
        if (a.variableTitle < b.variableTitle) return -1;
        if (a.variableTitle > b.variableTitle) return 1;
        return 0;
    });
    return theVariables;
}

function getSelectedGroup(
    availableGroups,
    variableGroup,
    theGroupForAll,
    selectedType,
    include,
    groupIdToUse
) {
    if (selectedType !== 'variable' || !include) return null;
    const theGroupId = groupIdToUse
        ? groupIdToUse
        : variableGroup
        ? variableGroup.id
        : null;
    if (!theGroupId || theGroupId < 0) return theGroupForAll;
    var matchingGroups = availableGroups.filter((g) => g.id === theGroupId);
    return matchingGroups.length > 0 ? matchingGroups[0] : theGroupForAll;
}
</script>

<style scoped>
.radio label {
    display: block;
    margin-bottom: 5px;
}
.spaced-out {
    margin-top: 20px;
    margin-bottom: 20px;
}

.dropdown-menu label.radio input[type='radio'] {
    visibility: hidden;
}

.dropdown-menu label.radio {
    padding-left: 10px;
}

.the-select-list {
    margin-top: 15px;
}

.search-text-box {
    height: 30px;
    margin-bottom: 10px;
    width: 250px;
}

.variable-group {
    margin-bottom: 10px;
}
.variable-group,
.dataTables-filter {
    width: 50%;
    float: left;
}
@media (max-width: 767px) {
    .variable-group,
    .dataTables-filter {
        width: 100%;
    }
}

.variable-group > label {
    display: inline-block;
    max-width: 100%;
    margin-bottom: 5px;
    font-weight: 700;
    font-size: 14px;
}

.checkbox,
.radio {
    position: relative;
    display: block;
    margin-top: 10px;
    margin-bottom: 10px;
}
</style>
